/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master mix volume`)
};

const es_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen de master mix`)
};

const de_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mastermix-Volumen`)
};

const nl_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mastermixvolume`)
};

const fr_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume de mix maître`)
};

const it_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume master mix`)
};

const pt_br2_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume de master mix`)
};

const pt_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume de master mix`)
};

const ja_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マスターミックス総量`)
};

const zh_pcr_mm_total = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混合液总体积`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_mm_total = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_mm_total(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_mm_total", locale)
	if (locale === "en") return en_pcr_mm_total(inputs)
	if (locale === "es") return es_pcr_mm_total(inputs)
	if (locale === "de") return de_pcr_mm_total(inputs)
	if (locale === "nl") return nl_pcr_mm_total(inputs)
	if (locale === "fr") return fr_pcr_mm_total(inputs)
	if (locale === "it") return it_pcr_mm_total(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_mm_total(inputs)
	if (locale === "pt") return pt_pcr_mm_total(inputs)
	if (locale === "ja") return ja_pcr_mm_total(inputs)
	return zh_pcr_mm_total(inputs)
};